import React from 'react';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material';
import { hasSelectedRole } from './EditUser';

function roleIsDisabled(roleValue, checkedRolesState) {
  let isDisabled = false;
  const roleStateKeys = Object.keys(checkedRolesState);
  if (roleValue === 'APPLICANT') {
    roleStateKeys.forEach((k) => {
      if (k !== 'APPLICANT' && checkedRolesState[k] === true) {
        isDisabled = true;
      }
    });
  } else {
    isDisabled = checkedRolesState['APPLICANT'];
  }

  return isDisabled;
}

function handleRoleChange(
  e,
  rolesCheckedState,
  setRolesCheckedState,
  setClaimsCheckedState,
  claimsCheckedState
) {
  const rolesCheckedStateCopy = { ...rolesCheckedState };
  rolesCheckedStateCopy[e.target.name] = e.target.checked;

  setRolesCheckedState(rolesCheckedStateCopy);

  if (e.target.name.toUpperCase() === 'APPLICANT' || !hasSelectedRole(rolesCheckedStateCopy)) {
    const claimsCheckedCopy = { ...claimsCheckedState };
    for (const key in claimsCheckedCopy) {
      claimsCheckedCopy[key] = false;
    }
    setClaimsCheckedState(claimsCheckedCopy);
  }
}

function AssignRoles({
  roles,
  rolesCheckedState,
  setRolesCheckedState,
  claimsCheckedState,
  setClaimsCheckedState,
}) {
  return (
    <Box>
      <AppBar position="static" color="secondary">
        <Toolbar variant="dense">
          <Typography variant="h6" color="inherit" component="div">
            Roles
          </Typography>
        </Toolbar>
      </AppBar>
      <Box>
        <Stack direction="row" spacing={2}>
          <Box>
            <FormGroup>
              {roles
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .filter((r, idx) => idx + 1 <= roles.length / 2)
                .map((r, idx) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={rolesCheckedState[r.value] || false}
                        disabled={roleIsDisabled(r.value, rolesCheckedState)}
                        name={r.value}
                        onChange={(e) =>
                          handleRoleChange(
                            e,
                            rolesCheckedState,
                            setRolesCheckedState,
                            setClaimsCheckedState,
                            claimsCheckedState
                          )
                        }
                      />
                    }
                    label={r.name}
                    key={idx}
                  />
                ))}
            </FormGroup>
          </Box>
          <Box>
            <FormGroup>
              {roles
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .filter((r, idx) => idx + 1 > roles.length / 2)
                .map((r, idx) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={rolesCheckedState[r.value] || false}
                        disabled={roleIsDisabled(r.name, rolesCheckedState)}
                        name={r.value}
                        onChange={(e) =>
                          handleRoleChange(
                            e,
                            rolesCheckedState,
                            setRolesCheckedState,
                            setClaimsCheckedState,
                            claimsCheckedState
                          )
                        }
                      />
                    }
                    label={r.name}
                    key={idx}
                  />
                ))}
            </FormGroup>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
}

AssignRoles.propTypes = {
  roles: PropTypes.array.isRequired,
  rolesCheckedState: PropTypes.objectOf(PropTypes.bool).isRequired,
  setRolesCheckedState: PropTypes.func.isRequired,
  claimsCheckedState: PropTypes.objectOf(PropTypes.bool).isRequired,
  setClaimsCheckedState: PropTypes.func.isRequired,
};

export default AssignRoles;
